import { render } from "./UnlockSixDiceModal.vue?vue&type=template&id=3d2e37de&scoped=true"
import script from "./UnlockSixDiceModal.vue?vue&type=script&lang=js"
export * from "./UnlockSixDiceModal.vue?vue&type=script&lang=js"

import "./UnlockSixDiceModal.vue?vue&type=style&index=0&id=3d2e37de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2e37de"]])

export default __exports__